module.exports = __webpack_public_path__ + "523f6fa591d554c9053445a5061315f8.MP3";